import React from "react";
import { SidebarContainers } from "@components";
import { SizesSideBarProps } from "./types";
import { STRING } from "@constants";
import { UnitSizeForm } from "./UnitSizeForm";
import { UnitSizeUpdate } from "@types";

export function UnitSizeSideBar({
  show,
  onClose,
  editValues,
}: SizesSideBarProps) {
  return (
    <SidebarContainers
      show={show}
      onClose={onClose}
      title={
        editValues
          ? STRING.UNIT_SIZE_FORM.TITLE_UPDATE
          : STRING.UNIT_SIZE_FORM.TITLE_CREATE
      }
    >
      <UnitSizeForm
        onClose={onClose}
        editValues={editValues as UnitSizeUpdate}
      />
    </SidebarContainers>
  );
}
